package org.hs_soft.runmynesto.domain.model.home.product

enum class SpeechRecognitionLanguageEnum(val speechLanguageName: String) {
    German("de-DE"),
    English("en-GB"),
    French("fr-FR"),
    Italian("it-IT"),
    Polish("pl-PL"),
    Russian("ru-RU"),
    Portuguese("pt-PT");
}